import React from "react";
import CSS from "./Notes.module.scss";

type NotesProps = {
  children:React.ReactNode|React.ReactNode[]
}
export default function Notes({children} : NotesProps) {
  return <div className={CSS.container}>{children}</div>
}